import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { IBaryTableFetchService } from './i-bary-table-fetch-service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { getTransporterGroupIdentifier, ITransporterGroup } from '../models/transporter-group.model';
import { ApplicationConfigService } from './application-config.service';
import { ApiProviderService } from './api-provider.service';
import { createRequestOption } from '../app/shared/util/request-util';

export type EntityResponseType = HttpResponse<ITransporterGroup>;
export type EntityArrayResponseType = HttpResponse<ITransporterGroup[]>;

@Injectable({ providedIn: 'root' })
export class TransporterGroupService implements IBaryTableFetchService<ITransporterGroup> {
  protected resourceUrl = API_ENDPOINTS.GROUP;

  constructor(protected http: HttpClient, protected apiProvider: ApiProviderService, protected applicationConfigService: ApplicationConfigService) {}

  create(entity: ITransporterGroup): Observable<EntityResponseType> {
    return this.apiProvider.post<ITransporterGroup>(this.resourceUrl, entity);
  }

  update(commercial: ITransporterGroup): Observable<EntityResponseType> {
    return this.apiProvider.put<ITransporterGroup>(`${this.resourceUrl}/${getTransporterGroupIdentifier(commercial)}`, commercial);
  }

  find(id: number): Observable<EntityResponseType> {
    return this.apiProvider.get<ITransporterGroup>(`${this.resourceUrl}/${id}`);
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider.get<ITransporterGroup[]>(this.resourceUrl, options);
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.apiProvider.delete(`${this.resourceUrl}/${id}`);
  }

  fillDataToShow(entities: ITransporterGroup[]): Observable<ITransporterGroup[]> {
    return of(entities);
  }
}
